export const blockIconsNotificationPhoneForwarded = (
	<span className='material-symbols-outlined'>phone_forwarded</span>
);
